import {OccasionType} from '../../../gql/pwa/graphql.ts';
import styles from './share_button.module.scss';
import {AltButton} from '../../../components/button/alt_button.tsx';
import React, {useCallback, useState} from 'react';
import {classNames} from '../../../support/classnames.ts';
import {useClickOutside} from '../../../support/use_click_outside.ts';
interface OwnProps {
    occasion?: OccasionType | null;
}
export function ShareButton({occasion}: OwnProps) {
    const [isOpen, setIsOpen] = useState(false);

    const ref = React.useRef<HTMLDivElement | null>(null);
    const closePopupCallback = useCallback(() => {
        setIsOpen(false);
    }, [setIsOpen]);
    useClickOutside(ref, closePopupCallback);

    const url = window.location;
    const text = `Check deze occasion: ${occasion?.brand} ${occasion?.model}`;

    return (
        <div className={styles.share_button_wrapper} ref={ref}>
            <AltButton onClick={() => setIsOpen(!isOpen)}>
                <i className="fa-light fa-share-alt" />
            </AltButton>

            <div
                className={classNames(styles.dropdown, {
                    [styles.open]: isOpen,
                })}
            >
                <AltButton target="_blank" to={`https://www.facebook.com/share.php?u=${url}`}>
                    <i className="fa-brands fa-facebook" />
                </AltButton>
                <AltButton target="_blank" to={`https://twitter.com/intent/tweet?text=${text}&url=${url}`}>
                    <i className="fa-brands fa-x-twitter" />
                </AltButton>
                <AltButton
                    target="_blank"
                    to={`https://wa.me/?text=${text}: ${url}`}
                    data-action={'share/whatsapp/share'}
                    data-text={`${text}: ${url}`}
                    data-href={url}
                >
                    <i className="fa-brands fa-whatsapp" />
                </AltButton>
            </div>
        </div>
    );
}
